import Vue from 'vue'
import axios from 'axios'
import store from '@/store'
import { VueAxios } from './axios'
import { ACCESS_TOKEN } from '@/store/mutation-types'
import { Toast } from 'vant'
import { getUrlParams ,replaceParamVal} from "@/utils/utility";

import {
  connectWebViewJavascriptBridge,
  getBrowserUserAgent,
} from "@/utils/utility";
var userAgent = getBrowserUserAgent();
var dsBridge = require("dsbridge");

// 创建 axios 实例

const service = axios.create({
  baseURL: process.env.VUE_APP_API_BASE_URL, // api base_url
  timeout: 60000 // 请求超时时间
})

const err = (error) => {
  if (error.response) {
    const data = error.response.data
    // const token = Vue.ls.get(ACCESS_TOKEN)
    if (error.response.status === 403) {
    //   notification.error({
    //     message: 'Forbidden',
    //     description: data.message
    //   })
        Toast.fail(data.message)
    }
    if (error.response.status === 401 && !(data.result && data.result.isLogin)) {
    //   notification.error({
    //     message: 'Unauthorized',
    //     description: 'Authorization verification failed'
    //   })
        Toast.fail('Authorization verification failed')
        // if (token) {
        //     // store.dispatch('Logout').then(() => {
        //     //     setTimeout(() => {
        //     //         window.location.reload()
        //     //     }, 1500)
        //     // })
        // }
    }
    if(error.response.status ===404 && error.response.data.code===401){
    //   notification.error({
    //     message: 'Unauthorized',
    //     description: error.response.data.msg
    //   })
        Toast.fail(error.response.data.msg)
    }
  }
  return Promise.reject(error)
}

// request interceptor
service.interceptors.request.use(config => {
  // var token = getUrlParams("token");
  // if(token == null) {
 var   token = sessionStorage.getItem(ACCESS_TOKEN);
 var TenantId= sessionStorage.getItem("TenantId")
  // }
  if(token!='null'&&token!=''&&token!=null){
    config.headers['Authorization'] = token // 让每个请求携带自定义 token 请根据实际情况自行修改
  }
  if( TenantId != 'null' && TenantId != '' && TenantId != null){
    config.headers['TenantId'] = TenantId
  }
  return config
}, err)

// response interceptor
service.interceptors.response.use((response) => {
 
  if (response.data.code == 401) {
    console.log(401,72)
    Vue.ls.remove(ACCESS_TOKEN);
    sessionStorage.removeItem(ACCESS_TOKEN)
   
    // console.log(401,72)
    if (userAgent.android) {
      dsBridge.call("tokenExpires", function (responseData) {
        // console.log(401,79)
        // console.log(responseData)
        if(responseData!=''){
          sessionStorage.setItem(ACCESS_TOKEN, responseData)
      
        }})
    }else{
      connectWebViewJavascriptBridge((bridge) => {

        window.WebViewJavascriptBridge.callHandler(
          "tokenExpires",
  
          function (responseData) {
            // console.log(401,79)
            // console.log(responseData)
            if(responseData!=''){
              sessionStorage.setItem(ACCESS_TOKEN, responseData)
          
            }
          
            // window.location.href= replaceParamVal( window.location.href, "token", responseData);
          }
        ); 
      }) 
    }
    
      window.WebViewJavascriptBridge.registerHandler(
        "tokenCallback",

        function (responseData) {
          // console.log(401,90)
          // console.log(responseData)
          if(responseData!=''){
            sessionStorage.setItem(ACCESS_TOKEN, responseData)
        
          }
       
       
          // window.location.href= replaceParamVal( window.location.href, "token", responseData);
          // window.location.reload();
        }
      );
   
  }
  return response.data
}, err)

const installer = {
  vm: {},
  install (Vue) {
    Vue.use(VueAxios, service)
  }
}

export {
  installer as VueAxios,
  service as axios
}
